const loadItems = (() => {
  let isLoading = false;

  return (button) => {
    if (isLoading) return;
    isLoading = true;

    const totalPages = parseInt($("[data-total-pages]").val());
    let currentPage = parseInt($("[data-current-page]").val());
    let currentPageScroll = currentPage + 1;

    currentPage = currentPage + 1;

    const rawValue = document.querySelector("[data-next-url]").value;

    const getUrlWithoutPhcursor = (value, pageValue) => {
      const url = new URL(value, window.location.origin);
      url.searchParams.set("page", pageValue);
      url.searchParams.delete("phcursor");
      return url.pathname + "?" + url.searchParams.toString();
    };

    const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);
    const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);

    button.setAttribute("disabled", "");
    button.classList.add("loading");
    $("[data-current-page]").val(currentPage);
    // A filter change replaces the grid while a page may still be loading; drop that page instead of appending
    // unfiltered products to the new grid.
    const requestGrid = document.querySelector(".load-more-grid");
    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        if (document.querySelector(".load-more-grid") !== requestGrid) return;
        $(".load-more-grid").append(
          $(responseHTML).find(".load-more-grid").html()
        );
        colorSwatches();
        window.updateShowingText();
      },
      complete: function () {
        if (currentPage <= totalPages) {
          const scollData = document.querySelector(".infinite-scroll__data");
          if (scollData && currentPage != totalPages) {
            const nextUrlScroll = $("[data-next-url]")
              .val()
              .replace(/page=[0-9]+/, "page=" + (currentPage + 1));

            scollData.querySelector("input[data-next-url]").dataset.nextUrl =
              nextUrlScroll;
            scollData.querySelector("input[data-next-url]").value =
              nextUrlScroll;
            scollData.querySelector(
              "input[data-current-page]"
            ).dataset.currentPage = currentPage;
            scollData.querySelector("input[data-current-page]").value =
              currentPage;
            checkVisibility();
          }
          button.removeAttribute("disabled");
          button.classList.remove("loading");
          if (currentPage == totalPages) {
            button.remove();
          }
          //$("[data-current-page]").val(currentPage);
        }
        isLoading = false;
      },
    });
  };
})();

window.updateShowingText = () => {
  let currentPage = parseInt($("[data-current-page]").val());
  const totalProducts = parseInt($("[data-total-products]").val());
  const perPage = $("[data-per-page]").data("per-page");
  if (totalProducts <= perPage) {
    currentPage = 1;
  }
  let text = "products";
  if (totalProducts == 1) {
    text = "product";
  }
  const productsShowing = Math.min(currentPage * perPage, totalProducts);
  const showingText = `Showing ${productsShowing} of ${totalProducts} ${text}`;
  $(".showing-text").text(showingText);
};

const checkVisibility = () => {
  // Hush (re-applied 2026-10-29; first fixed 2026-08-10 on an older theme copy):
  // - rootMargin: fast mobile flings skip the 0px-tall spinner between frames, so start loading 2000px early.
  // - strong references: Safari/WebKit can garbage-collect unreferenced IntersectionObservers.
  window.__infiniteScrollObservers = window.__infiniteScrollObservers || [];
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(spinner);
          }
        });
      },
      { rootMargin: "2000px 0px 2000px 0px" }
    );

    sectionObserver.observe(spinner);
    window.__infiniteScrollObservers.push(sectionObserver);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
  window.updateShowingText();
}

(function () {
  loadMore();
})();

document.addEventListener("DOMContentLoaded", function () {
  loadMore();
  document.addEventListener("shopify:section:load", function () {
    loadMore();
  });
});

// Hush: Safari/WebKit fallback. On iOS, IntersectionObserver notifications stop arriving after a page or two of
// appends, which freezes infinite scroll with the spinner on screen ("not showing everything" on iPhone). This
// scroll/touch-driven check loads the next page from the spinner's position directly and keeps going while the
// spinner stays near the viewport, until every page is loaded and the spinner is removed. loadItems() ignores
// calls while a request is in flight, so this never double-appends.
(function () {
  let scheduled = false;
  const check = () => {
    scheduled = false;
    const spinner = document.querySelector(".js-infinite-scroll");
    if (!spinner) return;
    const rect = spinner.getBoundingClientRect();
    if (rect.top < window.innerHeight + 2000 && rect.bottom > -2000) {
      loadItems(spinner);
      setTimeout(check, 1500);
    }
  };
  const onScroll = () => {
    if (!scheduled) {
      scheduled = true;
      setTimeout(check, 200);
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("touchmove", onScroll, { passive: true });
})();

// Hush: Back returns to the exact spot in a continuously scrolled list (collections and search), even many pages
// down. While the shopper scrolls, the number of loaded pages and the card at the top of the screen are saved to
// sessionStorage (saved continuously, not on pagehide: Chrome can drop late writes). On Back/Forward/reload the same
// pages are loaded again through loadItems() — one at a time, so the observers and the iOS fallback above can never
// double-append — and the card is put back at the same offset. A fresh visit (clicking a link to the collection)
// starts at the top as usual; a page restored from the back/forward cache keeps its own state.
(function () {
  // Filters re-render the grid, so always look it up instead of keeping the element from page load.
  var grid = document.querySelector(".load-more-grid");
  var pageInput = document.querySelector("[data-current-page]");
  if (!grid || !pageInput) return;
  function liveGrid() { return document.querySelector(".load-more-grid") || grid; }
  var store;
  try { store = window.sessionStorage; } catch (e) { return; }
  if (!store) return;

  function keyFor(href) {
    var u = new URL(href);
    ["page", "phcursor"].forEach(function (p) { u.searchParams.delete(p); });
    return "hush:list-scroll:" + u.pathname + "?" + u.searchParams.toString();
  }
  var KEY = keyFor(location.href);
  var CARD = ".load-more-grid .card-wrapper";
  var restoring = false;

  function currentPage() { return parseInt(document.querySelector("[data-current-page]").value, 10) || 1; }
  function topCard() {
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      if (r.bottom > 0) return { index: i, offset: Math.round(r.top) };
    }
    return null;
  }
  function save() {
    if (restoring) return;
    var card = topCard();
    try {
      store.setItem(keyFor(location.href), JSON.stringify({ page: currentPage(), index: card ? card.index : 0, offset: card ? card.offset : 0, y: Math.round(window.scrollY), savedAt: Date.now() }));
    } catch (e) {}
  }
  var timer = null;
  window.addEventListener("scroll", function () {
    if (timer) return;
    timer = setTimeout(function () { timer = null; save(); }, 250);
  }, { passive: true });
  window.addEventListener("pagehide", save);
  // Snapshot of the loaded grid, taken when the shopper leaves (tap on a product, pagehide), so Back can put it back
  // instantly instead of downloading every page again. Too big for sessionStorage -> no snapshot, the refetch below runs.
  var SNAP = KEY + ":grid";
  function snapshot() {
    if (restoring) return;
    save();
    var nextInput = document.querySelector("[data-next-url]");
    var snapKey = keyFor(location.href) + ":grid";
    var value = JSON.stringify({ page: currentPage(), next: nextInput ? nextInput.value : "", html: liveGrid().innerHTML.replace(/\s{2,}/g, " "), savedAt: Date.now() });
    // sessionStorage is shared with apps (StarApps caches every viewed product in it), so when it is full free space:
    // first our snapshots of other lists, then StarApps' product cache (it refetches a product on demand).
    var evictions = [
      function (k) { return k.indexOf("hush:list-scroll:") === 0 && /:grid$/.test(k) && k !== snapKey; },
      function (k) { return k.indexOf("starapps_vsk_storefront_detailed_") === 0; }
    ];
    for (var attempt = 0; attempt <= evictions.length; attempt++) {
      try { store.setItem(snapKey, value); return; } catch (e) {}
      if (attempt === evictions.length) break;
      try {
        Object.keys(store).filter(evictions[attempt]).forEach(function (k) { store.removeItem(k); });
      } catch (e) {}
    }
    try { store.removeItem(snapKey); } catch (e) {}
  }
  document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest(".load-more-grid a[href]")) snapshot(); }, true);
  window.addEventListener("pagehide", snapshot);

  var nav = (performance.getEntriesByType && performance.getEntriesByType("navigation")[0]) || {};
  var type = nav.type || (performance.navigation && performance.navigation.type === 2 ? "back_forward" : "navigate");
  var record = null;
  try { record = JSON.parse(store.getItem(KEY) || "null"); } catch (e) {}
  if (type !== "back_forward" && type !== "reload") {
    try { store.removeItem(KEY); store.removeItem(SNAP); } catch (e) {}
    return;
  }
  if (!record || Date.now() - record.savedAt > 6 * 3600 * 1000) return;

  restoring = true;
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";
  var target = Math.min(record.page, parseInt(document.querySelector("[data-total-pages]") && document.querySelector("[data-total-pages]").value, 10) || record.page);

  function place() {
    var cards = document.querySelectorAll(CARD);
    var card = cards[Math.min(record.index, cards.length - 1)];
    if (card) window.scrollTo(0, window.scrollY + card.getBoundingClientRect().top - record.offset);
    else window.scrollTo(0, record.y);
  }
  function finish() {
    place();
    // Late images can shift the layout; settle once more, then hand control back to the shopper.
    setTimeout(function () { place(); restoring = false; save(); }, 600);
  }
  // Fetch every missing page at once and insert them in order (sequential loading took ~1.5 s per page). The spinner
  // is detached meanwhile so the observers and the iOS fallback cannot load a page of their own in parallel.
  function restorePages() {
    var spinner = document.querySelector(".js-infinite-scroll");
    var button = document.querySelector(".js-load-more");
    var nextInput = document.querySelector("[data-next-url]");
    var totalPages = parseInt(document.querySelector("[data-total-pages]").value, 10) || target;
    var from = currentPage() + 1;
    if (from > target || !nextInput) return finish();
    var anchor = spinner && spinner.parentNode ? { parent: spinner.parentNode, next: spinner.nextSibling } : null;
    if (spinner) spinner.remove();
    var pageUrl = function (n) {
      var u = new URL(nextInput.value, location.origin);
      u.searchParams.set("page", n);
      u.searchParams.delete("phcursor");
      return u.pathname + "?" + u.searchParams.toString();
    };
    var pages = [];
    for (var n = from; n <= target; n++) pages.push(n);
    Promise.all(pages.map(function (n) {
      return fetch(pageUrl(n), { credentials: "same-origin" }).then(function (r) { return r.ok ? r.text() : ""; }).catch(function () { return ""; });
    })).then(function (htmls) {
      var loaded = from - 1;
      for (var i = 0; i < htmls.length; i++) {
        var doc = new DOMParser().parseFromString(htmls[i], "text/html");
        var part = doc.querySelector(".load-more-grid");
        if (!part) break;
        grid.insertAdjacentHTML("beforeend", part.innerHTML);
        loaded = pages[i];
      }
      document.querySelectorAll("[data-current-page]").forEach(function (el) { el.value = loaded; el.dataset.currentPage = loaded; });
      nextInput.value = pageUrl(loaded + 1);
      nextInput.dataset.nextUrl = nextInput.value;
      if (typeof colorSwatches === "function") colorSwatches();
      if (typeof window.updateShowingText === "function") window.updateShowingText();
      if (loaded >= totalPages) {
        if (button) button.remove();
      } else if (spinner && anchor) {
        anchor.parent.insertBefore(spinner, anchor.next);
        checkVisibility();
      }
      // A page that failed to arrive (network, rate limit) is loaded one at a time through loadItems() instead.
      if (loaded < target && (spinner || button)) return sequential(Date.now() + 30000);
      finish();
    });
  }
  function sequential(deadline) {
    var el = document.querySelector(".js-infinite-scroll") || document.querySelector(".js-load-more");
    if (Date.now() > deadline || currentPage() >= target || !el) return finish();
    if (!el.classList.contains("loading")) loadItems(el);
    setTimeout(function () { sequential(deadline); }, 150);
  }
  // Instant path: the snapshot holds the same pages the shopper had, so swap it in and place the card right away.
  function fromSnapshot() {
    var snap = null;
    try { snap = JSON.parse(store.getItem(SNAP) || "null"); } catch (e) {}
    // Only Back/Forward uses the copy: a reload must show the server's fresh grid (a copy saved before a fix or a
    // stock change would otherwise replace it), and a copy without product cards is never put back.
    if (type !== "back_forward" || !snap || !snap.html || snap.page < target || Date.now() - snap.savedAt > 30 * 60 * 1000) return false;
    if (snap.html.indexOf("card-wrapper") === -1) return false;
    var totalPages = parseInt(document.querySelector("[data-total-pages]").value, 10) || snap.page;
    grid.innerHTML = snap.html;
    document.querySelectorAll("[data-current-page]").forEach(function (el) { el.value = snap.page; el.dataset.currentPage = snap.page; });
    var nextInput = document.querySelector("[data-next-url]");
    if (nextInput && snap.next) { nextInput.value = snap.next; nextInput.dataset.nextUrl = snap.next; }
    if (snap.page >= totalPages) {
      var spinner = document.querySelector(".js-infinite-scroll"), button = document.querySelector(".js-load-more");
      if (spinner) spinner.remove();
      if (button) button.remove();
    }
    if (typeof colorSwatches === "function") colorSwatches();
    if (typeof window.updateShowingText === "function") window.updateShowingText();
    place();
    // Settle again as images above the card load, then hand control back to the shopper.
    [150, 500, 1200].forEach(function (ms) { setTimeout(place, ms); });
    setTimeout(function () { restoring = false; save(); }, 1300);
    return true;
  }
  if (fromSnapshot()) return;
  // No snapshot: refetch the pages, starting as soon as the DOM is ready (waiting for every image cost seconds).
  var start = function () { setTimeout(restorePages, 0); };
  if (document.readyState !== "loading") start(); else document.addEventListener("DOMContentLoaded", start);
})();
